module.exports = __webpack_public_path__ + "static/media/book.81701472.svg";